import React from 'react'
import { CheckCircle, CheckCircleOutline } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import { colors } from '@resiliatech/birdsong'
import { CheckListItemWithGoalInfo } from '../types'

type TaskCheckboxProps = {
  onToggleTaskComplete: (task: CheckListItemWithGoalInfo) => void
  task: CheckListItemWithGoalInfo
}

export const TaskCheckbox = ({
  onToggleTaskComplete,
  task,
}: TaskCheckboxProps) => {
  const tooltipTitle = task.isCompleted
    ? 'Mark as incomplete'
    : 'Mark as complete'

  return (
    <Tooltip title={tooltipTitle} arrow placement='top'>
      <IconButton
        onClick={() => onToggleTaskComplete(task)}
        size='small'
        sx={{
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '&:hover .MuiSvgIcon-root': {
            color: colors.illustration.darkBlue,
          },
        }}
      >
        {task.isCompleted ? (
          <CheckCircle
            sx={{
              color: colors.illustration.darkBlue,
              fontSize: '18px',
            }}
          />
        ) : (
          <CheckCircleOutline
            sx={{
              color: colors.text.disabled,
              fontSize: '18px',
              transition: 'color 0.3s',
            }}
          />
        )}
      </IconButton>
    </Tooltip>
  )
}
